import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/AlconForesight2025.png'


const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "activity" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "activity" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage('/alcon/froms')))
      }, "Click to Register")
    ])
  ]))
}